import LegalPage from './LegalPage';

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      path="/privacy"
      description="Privacy Policy for Rime, LLC. How we collect, use, and protect information when you visit hellorime.com or use our bookkeeping and payroll services."
      effectiveDate="January 1, 2026"
    >
      <p>
        Rime, LLC respects the privacy of our clients and website visitors. This Privacy Policy explains
        what information we may collect, how we use it, and the choices available to you when you
        visit hellorime.com or contact Rime, LLC about our services.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We may collect information you provide directly to us, including your name, email address,
        phone number, business name, and information you provide when requesting a consultation or
        communicating with us.
      </p>
      <p>
        If you become a client, we may also receive business and financial information reasonably
        necessary to provide bookkeeping or payroll services.
      </p>
      <p>
        Our website and third-party service providers may automatically collect limited technical
        information such as browser type, device information, IP address, referring pages, and
        website usage information.
      </p>

      <h2>How We Use Information</h2>
      <p>We may use information we collect to:</p>
      <ul>
        <li>Respond to inquiries and consultation requests</li>
        <li>Provide bookkeeping, payroll, setup, and cleanup services</li>
        <li>Communicate with clients about their accounts and services</li>
        <li>Schedule appointments</li>
        <li>Maintain and improve our website and services</li>
        <li>Protect our business, clients, and systems</li>
        <li>Comply with applicable legal obligations</li>
      </ul>
      <p>We do not sell personal information.</p>

      <h2>Financial Information</h2>
      <p>
        Providing bookkeeping and payroll services may require access to financial records,
        accounting software, payroll platforms, or related business systems.
      </p>
      <p>
        Rime, LLC seeks to use established platform permissions and secure user access whenever available
        rather than requesting or storing clients' primary banking credentials.
      </p>
      <p>
        Access is limited to information reasonably necessary to perform the services agreed upon
        with the client.
      </p>

      <h2>Service Providers</h2>
      <p>
        Rime, LLC may use third-party services to operate our business, including scheduling, accounting,
        payroll, communications, website hosting, and other business systems.
      </p>
      <p>
        These providers may process information on our behalf according to their own privacy
        policies and security practices.
      </p>

      <h2>Cookies and Website Analytics</h2>
      <p>
        hellorime.com may use cookies or similar technologies required for website functionality
        and, if enabled, analytics that help us understand how visitors use the site.
      </p>
      <p>
        You may be able to limit cookies through your browser settings. Disabling certain cookies
        may affect website functionality.
      </p>

      <h2>Information Sharing</h2>
      <p>
        We may share information with service providers when reasonably necessary to operate our
        business or provide requested services.
      </p>
      <p>
        We may also disclose information when required by law, to protect our legal rights, to
        prevent fraud or misuse, or in connection with a business transfer.
      </p>
      <p>We do not sell or rent client financial information for marketing purposes.</p>

      <h2>Data Retention</h2>
      <p>
        We retain information for as long as reasonably necessary to provide services, maintain
        business records, satisfy legal or contractual obligations, resolve disputes, and protect
        our rights.
      </p>

      <h2>Data Security</h2>
      <p>
        Rime, LLC uses reasonable administrative and technical measures intended to protect information
        in our possession. No method of electronic storage or transmission is completely secure, and
        we cannot guarantee absolute security.
      </p>

      <h2>Your Choices</h2>
      <p>
        You may contact us to request access to, correction of, or deletion of personal information
        we maintain about you, subject to applicable legal and recordkeeping requirements.
      </p>

      <h2>Third-Party Links</h2>
      <p>
        Our website may link to third-party websites or services. Rime, LLC is not responsible for the
        privacy practices or content of those third parties.
      </p>

      <h2>Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes will be posted on this page
        with an updated effective date.
      </p>

      <h2>Contact</h2>
      <p>Questions about this Privacy Policy may be sent to:</p>
      <p>
        Rime, LLC
        <br />
        <a href="mailto:contact@hellorime.com">contact@hellorime.com</a>
      </p>
    </LegalPage>
  );
}
